if (!customElements.get('quick-add-cantidad')) {
  customElements.define(
    'quick-add-cantidad',
    class QuickAddCantidad extends HTMLElement {
      connectedCallback() {
        this.variante = this.querySelector('[name="id"]')?.value;
        if (!this.variante || typeof subscribe !== 'function') return;

        // Cuando no alcanza, Shopify agrega lo que puede y responde con error.
        // El formulario del tema muestra el mensaje pero no repinta el carrito,
        // que quedaria mostrando lo de antes.
        this.cancelar = subscribe(PUB_SUB_EVENTS.cartError, (evento) => {
          if (evento.source !== 'product-form' || String(evento.productVariantId) !== String(this.variante)) return;
          this.repintarCarrito();
        });
      }

      disconnectedCallback() {
        this.cancelar?.();
      }

      async repintarCarrito() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        try {
          const secciones = drawer.getSectionsToRender();
          const raiz = window.Shopify?.routes?.root || '/';
          const html = await fetch(`${raiz}?sections=${secciones.map((s) => s.id).join(',')}`).then((r) => r.json());

          secciones.forEach((seccion) => {
            const elemento = seccion.selector ? document.querySelector(seccion.selector) : document.getElementById(seccion.id);
            if (elemento && html[seccion.id]) elemento.innerHTML = drawer.getSectionInnerHTML(html[seccion.id], seccion.selector);
          });

          // El fondo oscuro es nuevo: hay que volver a enseñarle a cerrar.
          drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));

          const carrito = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
          drawer.classList.toggle('is-empty', carrito.item_count === 0);
        } catch (e) {
          // Si no se pudo repintar, el carrito se ve al recargar.
        }
      }
    }
  );
}
